import CheckoutMainPage from "./main.container";

export default CheckoutMainPage;
